import { useState } from "react";
import useUser from "../../../../core/hooks/use-user";
import useModal from "../../../../core/hooks/use-modal";
import Datatable from "../../../../core/ui/components/Datatable";
import { toast, sweetAl } from "../../../../core/helpers/message-helper";
import { API_DOMAIN, API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import FormRecursos from "../components/form-recursos";
import { cambiarEstadoRecurso } from "../../services/recursos-service";

const Recursos = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState();

    const modalRecursos = useModal({
        title: "Crear Recurso",
        data: { recurso: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);
    const onCrearOEditarRecurso = () => dtInstance.ajax.reload();

    async function onCambiarEstadoRecurso(idRecurso, estado, table) {
        const accion = estado == 1 ? "activar" : "inactivar";
        const value = await sweetAl.confirm(
            `¿Seguro que desea ${accion} este recurso?`
        );

        if (value == true) {
            const resp = await cambiarEstadoRecurso(idRecurso, estado);

            if (!resp.status) {
                return sweetAl.error(resp.message);
            }

            sweetAl.success(resp.message);
            table.ajax.reload();
        }
    }

    let tableButtons = [];
    if (userCan('reservasCrearRecurso')) {
        tableButtons.push({
            titleAttr: "Crear Recurso",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalRecursos.open({
                    title: "Crear Recurso",
                    data: { recurso: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan('reservasEditarRecurso')) {
        tableButtons.push({
            titleAttr: "Editar Recurso",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalRecursos.open({
                    title: "Editar Recurso",
                    data: { recurso: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan('reservasActivarRecurso')) {
        tableButtons.push({
            titleAttr: "Activar Recurso",
            text: '<i class="fas fa-check"></i>',
            className: "btn btn-sm btn-primary",
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                onCambiarEstadoRecurso(data.id, 1, dt);
            },
        });
    }

    if (userCan('reservasInactivarRecurso')) {
        tableButtons.push({
            titleAttr: "Inactivar Recurso",
            text: '<i class="fas fa-trash"></i>',
            className: "btn btn-sm btn-danger",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                onCambiarEstadoRecurso(data.id, 0, dt);
            },
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "Recursos",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tableRecursos",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/reservas/recursos`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de recursos"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "descripcion" },
            { data: "img", defaultcontent: "" },
            { data: "icono", defaultcontent: "" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: [3, 4],
                createdCell: function (td, cellData) {
                    const path = `${API_DOMAIN}${cellData}`;
                    td.innerHTML = `
                        <img
                            src='${path}'
                            class='rounded-circle'
                            width='50px'
                            height='50px'
                            onerror="this.src='img/logo_csr_big.png'"
                        />
                    `;
                },
            },
            {
                targets: 5,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    RESERVAS / Recursos
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover text-center"
                    id="tableRecursos"
                >
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">Nombre</th>
                            <th className="text-center text-white">
                                Descripción
                            </th>
                            <th className="text-center text-white">Imágen</th>
                            <th className="text-center text-white">Ícono</th>
                            <th className="text-center text-white">Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormRecursos
                modalState={modalRecursos}
                onSave={onCrearOEditarRecurso}
            />
        </ContentWrapper>
    );
};

export default Recursos;
